import { render, staticRenderFns } from "./EmailConfirmPage.vue?vue&type=template&id=14471a14&scoped=true"
import script from "./EmailConfirmPage.vue?vue&type=script&lang=js"
export * from "./EmailConfirmPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14471a14",
  null
  
)

export default component.exports